import { Easing } from '@tweenjs/tween.js';
import { IResourceData } from 'Utility/Resource/IResourceData';
import { IElementData } from 'Prototype/UI/Element';
import { tVector4 } from 'Utility/ArrayHelper';
import { tEasing } from 'Utility/Types';

export enum CharacterPoses {
    Idle = 'idle',
    Happy = 'happy',
    Sad = 'sad',
}

export namespace ThemeSettings {
    export const eventActive: boolean = false;

    /* --------------------------- Harvest Button HUD --------------------------- */

    /** cacheKey to use for harvest button icon on WorldHUD*/
    export const HARVEST_BUTTON_HUD_CACHE_KEY: string = eventActive ? 'button_gold' : 'button_medium_blue_2';
    export const HARVEST_BUTTON_SCALE: number = eventActive ? 0.85 : 1;
    export const HARVEST_BUTTON_Y: number = eventActive ? -2 : -5;

    /** style key to use for harvest button text */
    export const HARVEST_BUTTON_TEXT_STYLE_KEY: string = eventActive ? 'theme.harvest_button' : 'HUD_Saga_Map.harvest';

    /** Harvest button particles to be shown */
    export const HARVEST_BUTTON_PARTICLE_TEXTURE_KEYS: string[] = eventActive ? ['flower2', 'flower4'] : [];

    /** Resource data for particle effect */
    export const HARVEST_BUTTON_PARTICLE_RESOURCE_DATA: IResourceData | undefined = eventActive
        ? {
              key: 'event_harvest_particle_data',
              path: 'resource/data/particles/harvest_button_event.json',
          }
        : undefined;

    export const HARVEST_BUTTON_DECORATIONS: IElementData[] = [
        {
            name: 'harvest_btn_theme_deco',
            layout: {
                anchors: [0.5, 0, 0.5, 0],
                pivot: [0.5, 0.5],
                offsets: [0, -3, 0, -3],
                scale: [0.9, 0.9],
                angle: 1,
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: eventActive ? 'button_decor' : 'blank',
                    },
                },
            ],
            children: [],
        },
    ];

    /* --------------------------- FieldHarvestHandler -------------------------- */
    /** cacheKey to use for submit button */
    export const HARVEST_MENU_SUBMIT_CACHE_KEY: string = eventActive ? 'button_gold' : 'button_medium_green';

    /** Offset to use for submit button */
    export const HARVEST_MENU_SUBMIT_OFFSET: tVector4 = eventActive ? [0, -2, 0, -2] : [0, 70, 0, 70];

    /** Offset to use for submit button BACKGROUND */
    export const HARVEST_MENU_SUBMIT_BG_OFFSET: tVector4 = eventActive ? [0, 0, 0, 0] : [-300, -30, -300, -30];

    /** Style to use for submit button */
    export const HARVEST_MENU_SUBMIT_TEXT_STYLE: string = eventActive
        ? 'theme.harvest_button'
        : 'popup.green_btn';

    /** cacheKey to use for AD button */
    export const HARVEST_MENU_AD_CACHE_KEY: string = eventActive ? 'button_gold' : 'button_medium_purple';

    /** Offset to use for AD button */
    export const HARVEST_MENU_AD_OFFSET: tVector4 = eventActive ? [0, -2, 0, -2] : [0, 70, 0, 70];

    /** Offset to use for AD button BACKGROUND */
    export const HARVEST_MENU_AD_BG_OFFSET: tVector4 = eventActive ? [0, 0, 0, 0] : [270, -30, 270, -30];

    /** Style to use for AD button */
    export const HARVEST_MENU_AD_TEXT_STYLE: string = eventActive
        ? 'theme.harvest_button'
        : 'popup.purple_btn';

    /** Size constains for menu */
    export const HARVEST_MENU_SIZE_CONSTRAINS = eventActive
        ? { heightMax: 723, heightMin: 723, widthMax: 1250, widthMin: 1226 }
        : { heightMax: 723, heightMin: 723, widthMax: 1250, widthMin: 1226 };

    /** Resource data for particle effect */
    export const HARVEST_MENU_REWARD_RESOURCE_DATA: IResourceData = {
        key: 'harvest_menu_reward_layout',
        path: eventActive
            ? 'resource/data/ui/themes/fieldHarvestRewardParams_Easter.json'
            : 'resource/data/ui/themes/fieldHarvestRewardParams.json',
    };

    /* -------------------------------- Character ------------------------------- */
    export const CHARACTER_CACHE_KEYS: Record<CharacterPoses, string> = {
        [CharacterPoses.Idle]: eventActive ? 'easter_girl_2' : 'character_idle_1',
        [CharacterPoses.Happy]: eventActive ? 'easter_girl_2' : 'character_happy_1',
        [CharacterPoses.Sad]: eventActive ? 'easter_girl_1' : 'character_failed_1',
    };

    /** The offsets to use for the character in the gold card ftux */
    export const CHARACTER_GOLD_FTUX_OFFSETS: tVector4 = eventActive ? [390, 60, 390, 60] : [400, 0, 400, 0];

    /** The offsets to use for the character in the level menus */
    export const CHARACTER_LEVEL_MENU_OFFSETS: tVector4 = eventActive ? [15, -50, 15, -50] : [15, -50, 15, -50];

    /** The offsets to use for the character in the level failed popups */
    export const CHARACTER_ON_LEVEL_FAIL_OFFSETS: tVector4 = eventActive ? [75, -80, 75, -80] : [25, -80, 25, -80];

    /* ----------------------------------- IAP ---------------------------------- */
    /** Should the sunday offer be suppressed */
    export const SUPPERSS_SUNDAY_OFFER: boolean = false;

    /* --------------------------------- Economy -------------------------------- */
    /** Multiplier applied to harvest reward */
    export const EVENT_HARVEST_MULTIPLIER: number = eventActive ? 2 : 1;

    /** Multiplier applied to harvest reward for ad button */
    export const AD_HARVEST_MULTIPLIER: number = eventActive ? 4 : 2;

    /* --------------------------------- Popups --------------------------------- */
    /** Easing to use in menu show animations */
    export const MENU_SHOW_EASING: tEasing = Easing.Exponential.InOut;

    /* --------------------------------- Assets --------------------------------- */
    const spriteSheetResourceData = {
        key: 'package_easter',
        path: 'resource/graphics/sprite_sheets/easter.json',
    };
    /** Assets to load on world start */
    export const WORLD_SYSTEM_PRELOAD_ASSETS: IResourceData[] = eventActive ? [spriteSheetResourceData] : [];

    /** Assets to load on for level menus */
    export const LEVEL_MENU_PRELOAD_ASSETS: IResourceData[] = eventActive ? [spriteSheetResourceData] : [];
}
